import { render, staticRenderFns } from "./FormTravel.vue?vue&type=template&id=62312e78"
import script from "./FormTravel.vue?vue&type=script&lang=js"
export * from "./FormTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports